const common = {
  siteName: 'Reserve Connect Urubici',
  tagline: 'Alojamiento en Serra Catarinense',
  loading: 'Cargando...',
  error: 'Error al cargar',
  retry: 'Intentar de nuevo',
  back: 'Volver',
  search: 'Buscar',
  filter: 'Filtrar',
  bookNow: 'Reservar Ahora',
  contactUs: 'Contáctenos',
  whatsapp: 'WhatsApp',
  phone: 'Teléfono',
  email: 'Correo electrónico',
  navigation: {
    home: 'Inicio',
    lodging: 'Alojamientos',
    restaurants: 'Restaurantes',
    experiences: 'Experiencias',
    events: 'Eventos',
    cityGuide: 'Dónde Ir',
    about: 'Sobre',
    contact: 'Contacto',
    groups: 'Grupos y Agencias',
    terms: 'Términos de Uso',
    privacy: 'Política de Privacidad',
    cookies: 'Política de Cookies',
    cancellation: 'Cancelación y Reembolso',
    login: 'Iniciar Sesión',
    centralReservas: 'Central de Reservas',
    announcers: 'Para Anunciantes',
  },
  header: {
    language: 'Idioma:',
    menuAriaLabel: 'Abrir menú',
  },
  footer: {
    brand: 'Reserve Connect',
    institutional: 'Institucional',
    services: 'Servicios',
    legal: 'Legal',
    rights: 'Todos los derechos reservados.',
    description: 'Plataforma de reservas integrada para conectar turistas con los mejores hoteles y experiencias locales.',
    whatsappContact: 'Hablar con la Central por WhatsApp',
    whatsappMessage: '¡Hola! Me gustaría ayuda con una reserva.',
    poweredBy: 'Powered by Readdy',
    links: {
      aboutUs: 'Sobre Reserve Connect',
      forHotels: 'Para Hoteles',
      municipalIntegration: 'Integración Municipal',
      cityPortal: 'Portal de la Ciudad',
      hotels: 'Hoteles',
      support: 'Soporte',
      faq: 'FAQ',
    },
  },
  aria: {
    previousSlide: 'Diapositiva anterior',
    nextSlide: 'Siguiente diapositiva',
    goToSlide: 'Ir a diapositiva {{number}}',
    switchLanguage: 'Cambiar idioma a {{lang}}',
  },
};
export default common;
